import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LoginHeader = () => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate('/homepage');
  };

  return (
    <div className="w-full bg-background border-b border-border">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <button
            onClick={handleHomeClick}
            className="flex items-center space-x-2 hover:opacity-80 transition-micro"
          >
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="Heart" size={20} color="white" />
            </div>
            <span className="text-xl font-semibold text-foreground">Share Good</span>
          </button>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-6">
            <button
              onClick={() => navigate('/cause-discovery')}
              className="text-sm text-muted-foreground hover:text-foreground transition-micro"
            >
              Discover Causes
            </button>
            <button
              onClick={() => navigate('/community-feed')}
              className="text-sm text-muted-foreground hover:text-foreground transition-micro"
            >
              Community
            </button>
            <Button
              variant="outline"
              size="sm"
              onClick={() => navigate('/register')}
            >
              Sign Up
            </Button>
          </div>

          {/* Mobile Menu */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate('/register')}
            >
              Sign Up
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginHeader;